__turbopack_context__.v({
  "container": "Highlight-module-scss-module__3djM2W__container",
  "highlight": "Highlight-module-scss-module__3djM2W__highlight",
  "media": "Highlight-module-scss-module__3djM2W__media",
});
